import {
  CREATEFRONTOFFICECOMPLAIN,
  CREATEFRONTOFFICEPHONECALLLOG,
  CREATEFRONTOFFICEPOSTAL,
  CREATEFRONTOFFICEPOSTALDISPATCH,
  CREATEFRONTOFFICEVISITOR,
  DELETEFRONTOFFICECOMPLAIN,
  DELETEFRONTOFFICEPHONECALLLOG,
  DELETEFRONTOFFICEPOSTAL,
  DELETEFRONTOFFICEPOSTALDISPATCH,
  DELETEFRONTOFFICEVISITOR,
  GETALLFRONTOFFICECOMPLAIN,
  GETALLFRONTOFFICEPHONECALLLOG,
  GETALLFRONTOFFICEPOSTAL,
  GETALLFRONTOFFICEPOSTALDISPATCH,
  GETALLFRONTOFFICEVISITOR,
  UPDATEFRONTOFFICECOMPLAIN,
  UPDATEFRONTOFFICEPHONECALLLOG,
  UPDATEFRONTOFFICEPOSTAL,
  UPDATEFRONTOFFICEPOSTALDISPATCH,
  UPDATEFRONTOFFICEVISITOR,
  GETBYIDFRONTOFFICEPHONECALLLOG,
  CREATEFRONTOFFICEESCORT,
  GETALLFRONTOFFICEESCORT,
  GETBYIDFRONTOFFICEESCORT,
  UPDATEFRONTOFFICEESCORT,
  DELETEFRONTOFFICEESCORT,
  CREATEFRONTOFFICETOKENGENERATION,
  GETALLFRONTOFFICETOKENGENERATION,
  GETBYIDFRONTOFFICETOKENGENERATION,
  UPDATEFRONTOFFICETOKENGENERATION,
  DELETEFRONTOFFICETOKENGENERATION,
  CREATEFRONTOFFICEPATIENTCHECKIN,
  GETALLFRONTOFFICEPATIENTCHECKIN,
  GETBYIDFRONTOFFICEPATIENTCHECKIN,
  UPDATEFRONTOFFICEPATIENTCHECKIN,
  DELETEFRONTOFFICEPATIENTCHECKIN,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEFRONTOFFICEPHONECALLLOG:
      return {
        ...state,
        frontofficephonelogSaveStatus: action.payload.success,
      };
    case GETALLFRONTOFFICEPHONECALLLOG:
      return {
        ...state,
        frontofficephonelogList: action.payload.data,
      };

    case UPDATEFRONTOFFICEPHONECALLLOG:
      return {
        ...state,
        frontofficephonelogUpdateStatus: action.payload.success,
      };

    case DELETEFRONTOFFICEPHONECALLLOG:
      return {
        ...state,
        frontofficephonelogDeleteStatus: action.payload.success,
      };
    case GETBYIDFRONTOFFICEPHONECALLLOG:
      return {
        ...state,
        frontofficephonelogById: action.payload.data,
      };
    case CREATEFRONTOFFICEVISITOR:
      return {
        ...state,
        frontofficevisitorSaveStatus: action.payload.success,
      };
    case GETALLFRONTOFFICEVISITOR:
      return {
        ...state,
        frontofficevisitorList: action.payload.data,
      };

    case UPDATEFRONTOFFICEVISITOR:
      return {
        ...state,
        frontofficevisitorUpdateStatus: action.payload.success,
      };

    case DELETEFRONTOFFICEVISITOR:
      return {
        ...state,
        frontofficevisitorDeleteStatus: action.payload.success,
      };
    case CREATEFRONTOFFICEPOSTAL:
      return {
        ...state,
        frontofficepostalSaveStatus: action.payload.success,
      };
    case GETALLFRONTOFFICEPOSTAL:
      return {
        ...state,
        frontofficepostalList: action.payload.data,
      };

    case UPDATEFRONTOFFICEPOSTAL:
      return {
        ...state,
        frontofficepostalUpdateStatus: action.payload.success,
      };

    case DELETEFRONTOFFICEPOSTAL:
      return {
        ...state,
        frontofficepostalDeleteStatus: action.payload.success,
      };
    case GETALLFRONTOFFICEPOSTALDISPATCH:
      return {
        ...state,
        frontofficepostaldispatchList: action.payload.data,
      };

    case UPDATEFRONTOFFICEPOSTALDISPATCH:
      return {
        ...state,
        frontofficepostaldispatchUpdateStatus: action.payload.success,
      };
    case CREATEFRONTOFFICEPOSTALDISPATCH:
      return {
        ...state,
        frontofficepostaldispatchSaveStatus: action.payload.success,
      };

    case DELETEFRONTOFFICEPOSTALDISPATCH:
      return {
        ...state,
        frontofficepostaldispatchDeleteStatus: action.payload.success,
      };
    case CREATEFRONTOFFICECOMPLAIN:
      return {
        ...state,
        frontofficecomplainSaveStatus: action.payload.success,
      };
    case GETALLFRONTOFFICECOMPLAIN:
      return {
        ...state,
        frontofficecomplainList: action.payload.data,
      };

    case UPDATEFRONTOFFICECOMPLAIN:
      return {
        ...state,
        frontofficecomplainUpdateStatus: action.payload.success,
      };

    case DELETEFRONTOFFICECOMPLAIN:
      return {
        ...state,
        frontofficecomplainDeleteStatus: action.payload.success,
      };
    case CREATEFRONTOFFICEESCORT:
      return {
        ...state,
        frontofficeescortSaveStatus: action.payload.success,
      };

    case GETALLFRONTOFFICEESCORT:
      return {
        ...state,
        frontofficeescortList: action.payload.data,
      };

    case GETBYIDFRONTOFFICEESCORT:
      return {
        ...state,
        frontofficeescortById: action.payload.data,
      };

    case UPDATEFRONTOFFICEESCORT:
      return {
        ...state,
        frontofficeescortUpdateStatus: action.payload.success,
      };

    case DELETEFRONTOFFICEESCORT:
      return {
        ...state,
        frontofficeescortDeleteStatus: action.payload.success,
      };
    // Token Generation
    case CREATEFRONTOFFICETOKENGENERATION:
      return { ...state, tokenGenerationSaveStatus: action.payload.success };
    case GETALLFRONTOFFICETOKENGENERATION:
      return { ...state, tokenGenerationList: action.payload.data };
    case GETBYIDFRONTOFFICETOKENGENERATION:
      return { ...state, tokenGenerationById: action.payload.data };
    case UPDATEFRONTOFFICETOKENGENERATION:
      return { ...state, tokenGenerationUpdateStatus: action.payload.success };
    case DELETEFRONTOFFICETOKENGENERATION:
      return { ...state, tokenGenerationDeleteStatus: action.payload.success };

    // Patient Check-in/Check-out
    case CREATEFRONTOFFICEPATIENTCHECKIN:
      return { ...state, patientCheckinSaveStatus: action.payload.success };
    case GETALLFRONTOFFICEPATIENTCHECKIN:
      return { ...state, patientCheckinList: action.payload.data };
    case GETBYIDFRONTOFFICEPATIENTCHECKIN:
      return { ...state, patientCheckinById: action.payload.data };
    case UPDATEFRONTOFFICEPATIENTCHECKIN:
      return { ...state, patientCheckinUpdateStatus: action.payload.success };
    case DELETEFRONTOFFICEPATIENTCHECKIN:
      return { ...state, patientCheckinDeleteStatus: action.payload.success };
    default:
      return state;
  }
}
